// Web Audio API sound effects — zero external files, works offline.

let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    audioCtx = new Ctx();
  }
  return audioCtx;
}

let userInteracted = false;
document.addEventListener('click',      () => { userInteracted = true; }, { once: true });
document.addEventListener('touchstart', () => { userInteracted = true; }, { once: true });

let soundEnabled = localStorage.getItem('you_sound') !== 'false';

export const toggleSound = (enabled) => {
  soundEnabled = enabled;
  localStorage.setItem('you_sound', enabled.toString());
};

export const isSoundEnabled = () => soundEnabled;

function playTone(frequency, duration, type = 'sine', volume = 0.15) {
  if (!soundEnabled || !userInteracted) return;
  try {
    const ctx  = getCtx();
    const osc  = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime);
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch (e) { /* silently fail */ }
}

// Soft click for button taps
export const playClick = () => playTone(800, 0.05, 'sine', 0.08);

// Cheerful ding for correct answer (C5 → E5 → G5)
export const playCorrect = () => {
  playTone(523, 0.15, 'sine', 0.12);
  setTimeout(() => playTone(659, 0.15, 'sine', 0.12), 80);
  setTimeout(() => playTone(784, 0.2,  'sine', 0.15), 160);
};

// Gentle bonk for wrong answer
export const playWrong = () => {
  playTone(300, 0.12, 'triangle', 0.08);
  setTimeout(() => playTone(250, 0.15, 'triangle', 0.06), 100);
};

// 3-note melody for story complete
export const playStoryComplete = () => {
  playTone(523, 0.2, 'sine', 0.12);
  setTimeout(() => playTone(659, 0.2, 'sine', 0.12), 200);
  setTimeout(() => playTone(784, 0.3, 'sine', 0.15), 400);
};

// 5-note ascending fanfare for level up
export const playLevelUp = () => {
  [523, 587, 659, 784, 1047].forEach((freq, i) => {
    setTimeout(() => playTone(freq, 0.25, 'sine', 0.12 + i * 0.02), i * 150);
  });
};

// Quick sparkle for XP earned
export const playXP = () => {
  playTone(1200, 0.08, 'sine', 0.06);
  setTimeout(() => playTone(1600, 0.08, 'sine', 0.08), 50);
};

// Rising whoosh for streak
export const playStreak = () => {
  if (!soundEnabled || !userInteracted) return;
  try {
    const ctx  = getCtx();
    const osc  = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(200, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.2);
    gain.gain.setValueAtTime(0.06, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.3);
  } catch (e) { /* silently fail */ }
};

// Happy munch for pet feeding / daily goal complete
export const playFeedPet = () => {
  playTone(400, 0.06, 'square', 0.05);
  setTimeout(() => playTone(500, 0.06, 'square', 0.05), 80);
  setTimeout(() => playTone(600, 0.08, 'square', 0.06), 160);
};
